
import React from 'react';
import { connect } from 'react-redux';
import { FaUser, FaBars, FaCogs, FaRegUserCircle } from 'react-icons/fa';
import { setCache } from '../../General/Actions.js';
import { BrowserRouter as Router, Route, Link, NavLink } from "react-router-dom";
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';
import PortalLoadingScreen from './portalLoadingScreen.js';
import ApuaBlueTextLogo from '../../ImageAssets/Apua_New_Logo.png';
// import ApuaBlueTextLogo from '../../ImageAssets/ApuaBlueTextLogo.png';
import SelectAllAccountComponent from './SelectAllAccountComponent.js';
import MyAccountComponent from './MyAccountComponent.js';
import BillingAndPaymentsComponent from './Billing&PaymentsComponent.js';
import SettingsComponent from './SettingsComponent.js';
import ServiceCenterComponent from './ServiceCenterComponent.js';

import HomeComponent from './HomeComponent.js';
import RechargeComponent from './RechargeComponent.js'
import InvoicesComponent from './InvoicesComponent.js'
import ChangePlanComponent from './ChangePlanComponent.js'
import RewardsPageComponent from './RewardsPageComponent.js'
import AccountSettingComponent from './AccountSettingsComponent.js'
import HistoryPageComponent from './HistoryPageComponent.js'
import CustomerSupportComponent from './CustomerSupportComponent.js'

import serviceCenter from '../../ImageAssets/serviceCenter.png';
import myAccount from '../../ImageAssets/myAccount.png';
import settings from '../../ImageAssets/settings.png';
import billPayment from '../../ImageAssets/billPayment.png';
import logout from '../../ImageAssets/logout.png';
import avatar from '../../ImageAssets/avatarsquare.png';
import { setUserDetails, setSwitchAccountModalFalse, setSwitchAccountModalTrue } from '../../General/Actions.js';
import { Collapse, Navbar, NavbarToggler, NavbarBrand, Nav, NavItem, ButtonDropdown, DropdownMenu, DropdownItem, Modal, ModalBody } from 'reactstrap';
import ApuaWhiteTextLogo from '../../ImageAssets/Apua_New_Logo_White.png';
// import ApuaWhiteTextLogo from '../../ImageAssets/ApuaWhiteTextLogo.png';
import closeIcon from '../../ImageAssets/closeIcon.png';
import blueBanner from '../../ImageAssets/blueBanner.png';
import redBanner from '../../ImageAssets/redBanner.png';

class PortalPageRootComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            billingName: "NA",
            contactNumber: "NA",
            isLoading: true,
            isAccountSelectionPageVisible: false,
            currentPage: "",
            dropdownOpen: false,
            allAccountList: [],
            billsAndPaymentStatus: 1,
            myOrderStatus: 1,
            settingsStatus: 1,
            serviceCenterStatus: 1,
            isToggleClicked: false,
            sticky: false,
            phoneNumber: "0",
            hideBillsAndPaymentForPrepaid: false
        };
    }

    toggleIconClicked() {
        this.state.isOpen = !this.state.isOpen
        if (this.state.isOpen) {
            document.body.classList.add('modal-open');
        } else {
            document.body.classList.remove('modal-open');
        }
        this.setState({
            dummy: "dummy"
        });
    }

    toggle = () => {
        this.setState({ dropdownOpen: !this.state.dropdownOpen });
    }


    optionsButtonClicked(type, needConfirmation) {
        if (type === "logout") {
            if (needConfirmation) {
                Swal.fire({
                    title: this.props.locales.logoutConfirmationTitleInSwal,
                    text: "",
                    type: '',
                    showCancelButton: true,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                    cancelButtonText: this.props.locales.cancelButtonTextInSwal,
                    reverseButtons: true
                }).then((result) => {
                    if (result.value) { this.optionsButtonClicked("logout"); }
                });
            } else {
                Network.executeAxios("logout", "GET", {}, (response) => {
                    if (response.STATUS === "SUCCESS") {
                        localStorage.removeItem("isUserLoggedIn");
                        localStorage.removeItem("uniqueToken");
                        localStorage.removeItem("currentAccount");
                        localStorage.removeItem("isSignInOptionClickedForMobile");
                        if (localStorage.getItem("isMobile")) {
                            localStorage.setItem("isSignInOptionClickedForMobile", true)
                            window.location.replace('/mobile=true&mobileNumber=' + this.state.phoneNumber);
                        } else {
                            localStorage.removeItem("isMobile");
                            window.location.replace('/');
                        }

                    } else {
                        Swal.fire(this.props.locales.logoutFailedTitleInSwal, "", "");
                    }
                });
            }
        } else if (type === "switchAccount") {
            this.props.setSwitchAccountModalTrue();
        }
    }

    userSelectAccountForSwitchAccount = (receivedAccountId) => {
        this.setState({
            isAccountSelectionPageVisible: false,
            isLoading: true
        });
        this.props.setSwitchAccountModalFalse();
        Network.executeAxios("changeAccountIdInSession", "POST", { "newAccountId": receivedAccountId, "isFirstTime": false }, (changeAccountIdInSessionResponse) => {
            if (changeAccountIdInSessionResponse.STATUS === "SUCCESS") {
                this.props.setSwitchAccountModalFalse();
                this.props.setUserDetails("currentAccount", receivedAccountId);
                localStorage.setItem("currentAccount", receivedAccountId);
                this.initialize();
            } else {
                Swal.fire({
                    title: 'Session expired, please login again',
                    text: "",
                    type: '',
                    timer: 2000,
                    showCancelButton: false,
                    confirmButtonText: this.props.locales.okButtonTextInSwal,
                }).then((result) => {
                    this.optionsButtonClicked("logout");
                });
            }

        });

    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateWindowDimensions);
        window.removeEventListener('scroll', this.handleScroll);
    }

    componentDidMount() {
        // window.addEventListener('scroll', this.handleScroll);
        // Network.executeAxios("fetchAccountInfo", "POST", {}, (getAllAccountsResponse) => {
        //     this.props.setCache("getAllAccountsResponse", getAllAccountsResponse);
        //     var currentBasicDetails = [];
        //     try {
        //         currentBasicDetails = getAllAccountsResponse.BillingSystem.response.dataset.account_info;
        //     } catch (err) {
        //         currentBasicDetails = [];
        //     }
        //     if (currentBasicDetails.length == 0) {
        //         Swal.fire({
        //             title: this.props.locales.internalErrorTitleInSwal,
        //             text: "",
        //             type: '',
        //             timer: 2000,
        //             showCancelButton: false,
        //             confirmButtonText: this.props.locales.okButtonTextInSwal,
        //         }).then((result) => {
        //             this.optionsButtonClicked("logout");
        //         });
        //     }
        //     var allAccounts = [];
        //     var accountIds = []
        //     for (var i = 0; i < currentBasicDetails.length; i++) {
        //         if (accountIds.indexOf(currentBasicDetails[i].account_id) == -1) {
        //             var tempObject = currentBasicDetails[i];
        //             tempObject["accountId"] = currentBasicDetails[i].account_id;
        //             allAccounts.push(tempObject);
        //             accountIds.push(currentBasicDetails[i].account_id);
        //         }
        //     }
        //     this.props.setUserDetails("accounts", allAccounts);
        //     var currentAccountInLocalStorage = localStorage.getItem("currentAccount");
        //     if (currentAccountInLocalStorage != null) {
        //         this.props.setUserDetails("currentAccount", currentAccountInLocalStorage);
        //         this.initialize();
        //     } else if (allAccounts.length == 1) {
        //         this.userSelectAccountForSwitchAccount(allAccounts[0].accountId);
        //     } else {
        //         this.setState({
        //             isAccountSelectionPageVisible: true,
        //             isLoading: false
        //         });
        //     }
        //     //     Network.executeAxios("fetchCcmConfig", "POST", {}, (ccmConfigResponse) => {
        //     this.props.setCache("ccmConfigResponse", {});
        //     // });
        // });
        this.updateWindowDimensions();
        window.addEventListener('resize', this.updateWindowDimensions);
        // this.setCurrentPage();
        // this.setState({ phoneNumber: this.getUrlParameter("mobileNumber") })
    }

    getUrlParameter(param) {
        var found;
        window.location.pathname.substr(1).split("&").forEach(function (item) {
            if (param == item.split("=")[0]) {
                found = item.split("=")[1];
            }
        });
        return found;
    };

    setCurrentPage() {
        if (window.location.pathname === "/") { this.setState({ currentPage: "Overview" }) }
        else if (window.location.pathname === "/mobile=true&mobileNumber=" + this.state.phoneNumber) { this.setState({ currentPage: "Overview" }) }
        else if (window.location.pathname === "/myOrder") { this.setState({ currentPage: "My Order" }) }
        else if (window.location.pathname === "/billingAndPayments") { this.setState({ currentPage: "Billing And Payments" }) }
        else if (window.location.pathname === "/settings") { this.setState({ currentPage: "Settings" }) }
        else if (window.location.pathname === "/serviceCenter") { this.setState({ currentPage: "Service Center" }) }
        else if (window.location.pathname === "/changePlan") { this.setState({ currentPage: "" }) }
    }

    initialize = () => {
        Network.executeAxios("querySubscriber", "POST", {}, (querySubscriberResponse) => {
            this.props.setCache("querySubscriberResponse", querySubscriberResponse);
            Network.executeAxios("fetchServiceInfo", "POST", {}, (fetchServiceInfoResponse) => {
                var serviceListResponse = [];
                try {
                    serviceListResponse = fetchServiceInfoResponse.BillingSystem.response.dataset.service_info;
                } catch (err) {
                    serviceListResponse = [];
                }
                this.props.setCache("serviceListResponse", serviceListResponse);

                if (serviceListResponse.length == 1) {
                    if (serviceListResponse[0].connection_type !== "1") {
                        this.setState({ hideBillsAndPaymentForPrepaid: true })
                    }
                }

                Network.executeAxios("fetchAccountDetails", "POST", {}, (fetchAccountDetailsResponse) => {
                    this.props.setCache("fetchAccountDetailsResponse", fetchAccountDetailsResponse);
                    this.initializePortalRoot(querySubscriberResponse);
                });
            });
        });
    }

    handleScroll = (event) => {
        try {
            let currentScrollY = window.scrollY;
            if (currentScrollY > 90) {
                this.state.sticky = false
                this.setState({ isFloatingSubMenuVisible: true });
            } else {
                this.state.sticky = false
                this.setState({ isFloatingSubMenuVisible: false });
            }
        } catch (err) { }
    }


    modalCancelButtonClicked = () => {
        this.props.setSwitchAccountModalFalse();
    }

    populateAllAcounts() {
        var finalAccountList = [];
        var values = [];
        var value;

        for (var i = 0; i < this.props.userDetails.accounts.length; i++) {
            value = this.props.userDetails.accounts[i].accountId;

            if (values.indexOf(value) === -1) {
                finalAccountList.push(this.props.userDetails.accounts[i]);
                values.push(value);
            }
        }
        this.state.allAccountList = finalAccountList;
        const allAccounts = this.state.allAccountList.map((item, key) => {
            //let userName= ""+item.account_first_name+" "+item.account_last_name;
            let userName = "" + item.profile_name
            if (this.props.userDetails.currentAccount == item.accountId) {
                return (
                    <div className="col-md-6 mb-4" key={key}>
                        <div className="switchAccountDetail d-flex mx-auto" style={{ border: '1.5px solid #0049A5', cursor: 'not-allowed' }}>
                            <span className="m-0 pt-0 text-center" style={{ color: '#ffffff', backgroundColor: '#0049A5', borderBottomLeftRadius: 5, borderBottomRightRadius: 5, width: '30%', position: 'absolute', top: 1, right: '35%', fontSize: 10, fontWeight: 500 }}>{this.props.locales.selectedAccountTextInSwitchAccountModal}</span>
                            <div className=" px-1 text-center pt-3">
                                <div className="iconContainer ">
                                    <FaUser style={{ fontSize: 20, marginTop: 14 }} />
                                </div>
                            </div>
                            <div className="pl-3 p-0 pt-2 my-auto" style={{ width: '100%' }}>
                                <div className="" style={{ fontSize: 16, fontWeight: 500, color: '#404042' }}>{userName}</div>
                                <div className="" style={{ fontSize: 14, fontWeight: 500, color: '#404042' }}>{item.accountId}</div>
                                <div className="pt-2 pb-1" style={{ fontSize: 16, fontWeight: 300, color: '#6D6D6D' }}>{item.notification_email_id}</div>
                            </div>
                        </div>
                    </div>
                );
            }
            else {
                return (
                    <div className="col-md-6 mb-4 " key={key}>
                        <div className="switchAccountDetail d-flex mx-auto" onClick={() => this.userSelectAccountForSwitchAccount(item.accountId)}>
                            <div className=" px-1 text-center pt-3">
                                <div className="iconContainer ">
                                    <FaUser style={{ fontSize: 20, marginTop: 14 }} />
                                </div>
                            </div>
                            <div className="pl-3 p-0 pt-2 my-auto" style={{ width: '100%' }}>
                                <div className="" style={{ fontSize: 16, fontWeight: 500, color: '#404042' }}>{userName}</div>
                                <div className="" style={{ fontSize: 14, fontWeight: 500, color: '#404042' }}>{item.accountId}</div>
                                <div className="pt-2 pb-1" style={{ fontSize: 16, fontWeight: 300, color: '#6D6D6D' }}>{item.notification_email_id}</div>
                            </div>
                        </div>
                    </div>
                );
            }
        });
        return (<div className="switchAccountDetailContainer col-md-12 row" style={{ marginTop: '-47px', backgroundColor: 'transparent' }}>{allAccounts}</div>)
    }


    updateWindowDimensions = () => {
        this.setState({ windowWidth: window.innerWidth, windowHeight: window.innerHeight });
    }

    initializePortalRoot(receivedResponse) {
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }
        var finalBillingName = "";
        var finalContactNumber = "";
        var customerType = ""
        var customerCategory = "";
        var customerSubCategory = "";
        var lastName = "";
        for (var i = 0; i < params.length; i++) {
            if (params[i].id === "first_name") {
                finalBillingName = params[i].value;
            }
            if (params[i].id === "last_name") {
                lastName = params[i].value;
            }
            if (params[i].id === "contact_number_1") {
                finalContactNumber = params[i].value;
            }
            if (params[i].id === "subscriber_category") {
                customerCategory = params[i].value;
            }
            if (params[i].id === "subscriber_sub_category") {
                customerSubCategory = params[i].value;
            }
            if (params[i].id === "profile_type") {
                customerType = params[i].value;
            }
        }
        this.props.setUserDetails("billingName", finalBillingName + " " + lastName);
        this.props.setUserDetails("customerCategory", customerCategory);
        this.props.setUserDetails("customerSubCategory", customerSubCategory);
        this.props.setUserDetails("customerType", customerType);
    
        this.setState({
            billingName: finalBillingName + " " + lastName,
            contactNumber: finalContactNumber,
            customerCategory: customerCategory,
            customerSubCategory: customerSubCategory
        },() => {
            this.getAccessPrivilages();
            console.log(this.state.billingName)
        });


    }

    getAccessPrivilages() {
        var dataToSend = {
            customerCategory: this.state.customerCategory,
            customerSubCategory: this.state.customerSubCategory
        }
        Network.executeAxios("fetchAccessPrivilages", "POST", dataToSend, (accessPrivilagesResponse) => {
            if (accessPrivilagesResponse.STATUS === "SUCCESS") {
                this.initializeFeatures(accessPrivilagesResponse);
            } else {
                console.log("No Restrictions found for this profile");
                setTimeout(() => {
                    this.setState({ isLoading: false });
                }, 1000);
            }
        });
    }

    initializeFeatures(response) {
        var featureArray = response.FEATURES;
        var finalFeatures = [];
        for (var i = 0; i < featureArray.length; i++) {
            var temp = {
                featureName: featureArray[i].FEATURE_NAME,
                status: featureArray[i].STATUS
            }
            finalFeatures.push(temp);
        }
        this.props.setUserDetails("features", finalFeatures);
        this.manageFeatures();
    }

    manageFeatures() {        // 1-show feature   0-hide feature
        var billsAndPaymentStatus = 1;
        var myOrderStatus = 1;
        var settingsStatus = 1;
        var serviceCenterStatus = 1;
        var features = this.props.userDetails.features;
        if (features.length > 0) {
            for (var i = 0; i < features.length; i++) {
                if (features[i].featureName === "ViewBillsAndPayments") {
                    billsAndPaymentStatus = features[i].status;
                } else if (features[i].featureName === "ViewMyOrders") {
                    myOrderStatus = features[i].status;
                } else if (features[i].featureName === "Settings") {
                    settingsStatus = features[i].status;
                } else if (features[i].featureName === "ViewServiceCenter") {
                    serviceCenterStatus = features[i].status;
                }
            }
        }
        this.setState({
            billsAndPaymentStatus: billsAndPaymentStatus,
            myOrderStatus: myOrderStatus,
            settingsStatus: settingsStatus,
            serviceCenterStatus: serviceCenterStatus,
            isLoading: false
        })
    }

    navLinkClicked(type) {
        setTimeout(() => {
            this.setState({
                currentPage: type,
                isToggleClicked: false,
                isOpen: false
            });
        }, 500);
        document.body.classList.remove('modal-open');
    }

    navBarClicked() {
        window.location.href = "/";
    }

    render() {
        // if (this.state.isLoading == true) {
        //     return (<PortalLoadingScreen />);
        // } else if (this.state.isAccountSelectionPageVisible) {
        //     const portalOuterMainContainerStyle = { height: this.state.windowHeight + 'px' };
        //     return (
        //         <div className="d-flex flex-column animated fadeIn" style={portalOuterMainContainerStyle}>
        //             <SelectAllAccountComponent reInitialize={this.userSelectAccountForSwitchAccount} />
        //         </div>
        //     );
        // } else {
            return (this.componentContent());
        // }
    }

    componentContent() {
        const portalMainContainerStyle = { height: this.state.windowHeight + 'px', background: 'red' };
        return (
            <div id="portalOuterMainContainer" className="col-md-12 p-0 m-0 animated fadeIn" style={{height: this.state.windowHeight + 'px',display:"flex",flex:1}}>
                <div id="sessionOutDiv"></div>
                <div id="toastPopup" className="animated slideInRight d-none"></div>

                {/* For Mobile */}


                <div className="col-md-12 p-0 m-0">
                    <Router>
                        <div id="portalPageTopComponent" className={this.state.sticky ? "sticky" : ""}>
                            {/* <div className="navbar-header d-md-none d-flex justify-content-between px-2" > */}
                            <Navbar color="light" light className="d-md-none p-0">
                            {this.state.isOpen == false ?
                                <div style={{ background: '#0285CA' }} className="col-md-12 row p-0 m-auto justify-content-between py-2 px-3 align-items-center">
                                    <NavbarBrand className="pl-3">
                                        <div className=""  onClick={() => { this.navBarClicked() }} style={{cursor: 'pointer'}}>
                                            <div className="col-md-6 pl-5 ml-3"><img alt="" src={ApuaWhiteTextLogo} /></div>
                                        </div>
                                    </NavbarBrand>
                                    {/* <NavbarToggler onClick={() => this.toggleIconClicked()} style={{ zIndex: 20 }} /> */}
                                  
                                        <FaBars className="pr-3 pt-2" color="#FFFFFF" style={{ zIndex: 18 }} size="30" onClick={() => this.toggleIconClicked()}/>
    
                                </div>
                                : null }
                            <div className="d-flex w-100" style={{top:0, bottom: 0}}>
                            <div style={{ flex: "1", background: 'rgba(100, 100, 100, 0.5)' }} className="leftTransparentPart" onClick={() => this.toggleIconClicked()}></div>
                                <div style={{ flex: "5" }} className="contentPart">
                                    <Collapse isOpen={this.state.isOpen} navbar style={{}} className="ml-auto">
                                        <Nav className="m-auto text-center justify-content-between" navbar>
                                        <div className="py-3 d-flex align-items-center" style={{ backgroundColor: '#0285ca', borderBottom: '1px solid #d3d3d3' }}>
                                                    <div className="px-3">
                                                        <NavItem>
                                                            <NavLink exact to="/settings" onClick={() => { this.navLinkClicked('settings') }}> <FaCogs style={{ fontSize: 20, marginTop: 14, color: "#ffffff" }} /></NavLink>
                                                        </NavItem>
                                                    </div>
                                                    <div className="d-flex align-items-center flex-grow-1 justify-content-end pr-4">
                                                        <div className="px-3">
                                                            <div style={{ color: '#fafafa', fontSize: 14, fontWeight: 'bold', wordBreak: 'break-word' }}>{this.state.billingName}</div>
                                                            {/* <div style={{ color: '#fafafa', fontSize: 12 }} onClick={() => { this.optionsButtonClicked("switchAccount") }}>{this.props.locales.switchAccountText}</div> */}
                                                        </div>
                                                        <div className=""> <FaRegUserCircle style={{ fontSize: 26, color: "#fafafa" }} /></div>
                                                    </div>
                                                </div>

                                                <NavItem className={window.location.pathname === "/mobile=true&mobileNumber="+this.state.phoneNumber?"d-flex align-items-center p-3 activeLink navItem":"d-flex align-items-center p-3 navItem"}>
                                                <img src={myAccount} alt="" className="px-3" /><NavLink exact to={`/mobile=true&mobileNumber=${this.state.phoneNumber}`} 
                                                className={window.location.pathname === "/mobile=true&mobileNumber="+this.state.phoneNumber?"navLink activeNavLink":"navLink"}
                                                 onClick={() => { this.navLinkClicked('') }}>{this.props.locales.myAccountNavLink}</NavLink>
                                                </NavItem>

                                                {this.state.billsAndPaymentStatus == 1 && this.state.hideBillsAndPaymentForPrepaid == false ?
                                                <NavItem className={window.location.pathname === "/billingAndPayments"?"d-flex align-items-center p-3 activeLink navItem":"d-flex align-items-center p-3 navItem"}>
                                                <img src={billPayment} alt="" className="px-3"/><NavLink to="/billingAndPayments" className={window.location.pathname === "/billingAndPayments"?"navLink activeNavLink":"navLink"} onClick={() => { this.navLinkClicked('Billing And Payments') }}>{this.props.locales.billsAndPaymentsNavLink}</NavLink>
                                                </NavItem>
                                                : null }

                                                <NavItem className={window.location.pathname === "/serviceCenter"?"d-flex align-items-center p-3 activeLink navItem":"d-flex align-items-center p-3 navItem"}>
                                                <img src={serviceCenter} alt="" className="px-3"/><NavLink to="/serviceCenter" className={window.location.pathname === "/serviceCenter"?"navLink activeNavLink":"navLink"} onClick={() => { this.navLinkClicked('Service Center') }}>{this.props.locales.serviceCenterNavLink}</NavLink>
                                                </NavItem>
                                                
                                                <div className="w-100 p-2 text-left" style={{color:'red',position:'fixed',bottom:0,borderTop:'1px solid #4A4A4A'}} onClick={() => { this.optionsButtonClicked("logout", true) }}>
                                                <img src={logout} alt="" className="px-3"/> {this.props.locales.logoutText}
                                                </div>
                                        </Nav>
                                    </Collapse>
                                </div>
                            </div>
                            </Navbar>
                     
                            <Navbar 
                            //  style={{ backgroundImage: `url(${blueBanner})`, backgroundSize: 'cover' }} 
                             id="navbarPart" color="light" light expand="md" className="p-0 m-0 d-none d-sm-block">
                                        <img alt="" src={redBanner} width={"100%"} height={"380px"}/>

                                <NavbarToggler onClick={() => this.toggleIconClicked()} />

                                
                                
                                <Collapse isOpen={this.state.isOpen} navbar style={{position:"absolute",top:20,width:"100%"}}>
                                    <Nav className="m-auto text-center " navbar style={{ width: '90%', flexDirection:"column" }}>
                                        <div className='d-flex justify-content-between' style={{}}>
                                            <div className="" style={{ cursor: 'pointer' }} onClick={() => { this.navBarClicked() }} >
                                                <div className="col-md-6 pl-5 ml-3"><img alt="" src={ApuaWhiteTextLogo} /></div>
                                            </div>
                                            <div className="d-flex align-items-center pl-lg-5 pl-md-3">
                                                <div className="pr-3" style={{ color: '#FFFFFF', fontWeight: 700, fontSize: 20 }}>{this.state.billingName}</div>
                                                <img src={avatar} alt="" className="" width="40" height="40" />
                                                {/* <ButtonDropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} >
                                                    <div style={{ paddingLeft: 10, background: 'transparent', border: 'unset', cursor: 'pointer' }} onClick={() => { this.toggle() }}><img src={avatar} alt="" className="" width="40" height="40" /></div>
                                                    <DropdownMenu style={{ left: '-60px' }}>
                                                        {this.state.settingsStatus == 1 ?
                                                            <DropdownItem style={{ fontWeight: 400 }} tag={Link} to={"/settings"} onClick={() => { this.navLinkClicked('Settings') }}>{this.props.locales.settingsNavLink}</DropdownItem>
                                                            : null}
                                                        <DropdownItem onClick={() => { this.optionsButtonClicked("logout", true) }}>{this.props.locales.logoutText}</DropdownItem>
                                                    </DropdownMenu>
                                                </ButtonDropdown> */}
                                                <div className="pl-3" style={{ color: '#FFFFFF', fontWeight: "normal", fontSize: 14, cursor: 'pointer'}} onClick={() => { this.optionsButtonClicked("logout", true) }}>Logout</div>
                                            </div>
                                        </div>


                                        
                                        <div className="d-flex justify-content-end" style={{}}>
                                            <NavItem className="d-flex align-items-center p-2" style={{}}>
                                                <NavLink exact to="/" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('') }}>Home</NavLink>
                                            </NavItem>
                                            <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2" style={{}}>
                                                <NavLink to="/Recharge" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Recharge') }}>Recharge</NavLink>
                                            </NavItem>
                                            <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2" style={{}}>
                                                <NavLink to="/Invoices" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Invoices') }}>Invoices</NavLink>
                                            </NavItem>
                                            <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-2">
                                                <NavLink to="/ChangePlan" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Change Plan') }}>Change Plan</NavLink>
                                            </NavItem>
                                            <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                                <NavLink to="/Rewards" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Rewards') }}>Rewards</NavLink>
                                            </NavItem>
                                            <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                                <NavLink to="/AccountSettings" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Account Settings') }}>Account Settings</NavLink>
                                            </NavItem>
                                            <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                                <NavLink to="/History" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('History') }}>History</NavLink>
                                            </NavItem>
                                            <NavItem className="d-flex align-items-center p-2 pl-lg-3 pl-md-3">
                                                <NavLink to="/CustomerSupport" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Customer Support') }}>Customer Support</NavLink>
                                            </NavItem>
                                            {/* {this.state.billsAndPaymentStatus == 1 && this.state.hideBillsAndPaymentForPrepaid == false ?
                                                <NavItem className="d-flex align-items-center p-2 pl-lg-5 pl-md-3">
                                                    <NavLink to="/billingAndPayments" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Billing And Payments') }}>{this.props.locales.billsAndPaymentsNavLink}</NavLink>
                                                </NavItem>
                                                : null} */}

                                            {/* <NavItem className="d-flex align-items-center p-2 pl-5">
                                                <NavLink to="/settings" activeClassName="activeMenu" onClick={() => { this.navLinkClicked('Settings') }} >Settings</NavLink>
                                            </NavItem> */}
                                            {/* {this.state.serviceCenterStatus == 1 ?
                                                <NavItem className="d-flex align-items-center p-2 pl-lg-5 pl-md-3">
                                                    <NavLink to="/serviceCenter" activeClassName="activeMenu px-3" onClick={() => { this.navLinkClicked('Service Center') }}>{this.props.locales.serviceCenterNavLink}</NavLink>
                                                </NavItem>
                                                : null} */}

                                          
                                        </div>
                                    </Nav>
                                </Collapse>
                            </Navbar>
                            
                        </div>
                        <div id="" className="p-1 p-md-5 col-md-12" style={{flex: 1,display:"flex",marginTop:-100}}>
                            {/* <div className="col-md-12 d-none d-lg-block portalTopBanne" style={{ height: 145, position: 'relative' }}>
                                <div className="ml-auto mr-auto mt-5 d-none" style={{ width: '85%' }}>
                                    <div style={{ fontSize: 24, color: '#ffffff' }}>{this.props.locales.welcomeTextInOverview} <span style={{ fontWeight: 500 }}> {this.state.billingName} </span></div>
                                    <div style={{ fontSize: 14, color: '#ffffff' }}>{this.state.currentPage}</div>
                                </div>
                            </div> */}
                            
                            <Route exact path="/" component={HomeComponent} />
                            <Route exact path="/Recharge" component={RechargeComponent} />
                            <Route exact path="/Invoices" component={InvoicesComponent} />
                            <Route exact path="/ChangePlan" component={ChangePlanComponent} />
                            <Route exact path="/Rewards" component={RewardsPageComponent} />
                            <Route exact path="/AccountSettings" component={AccountSettingComponent} />
                            <Route exact path="/History" component={HistoryPageComponent} />
                            <Route exact path="/CustomerSupport" component={CustomerSupportComponent} />
                            <Route path={`/mobile=true&mobileNumber=${this.state.phoneNumber}`} component={MyAccountComponent} />
                            <Route path="/billingAndPayments" component={BillingAndPaymentsComponent} />
                            <Route path="/settings" component={SettingsComponent} />
                            <Route path="/serviceCenter" component={ServiceCenterComponent} />
                            
                        </div>
                        <div className="col-md-12 footer-part row m-0 mt-2 text-center justify-content-center align-content-center">
                            Copyright 2024 APUA INET
                        </div>
                        

                    </Router>
                    
                </div>
               
                <Modal isOpen={this.props.isSwitchAccountModalVisible} size="lg" centered>
                    <ModalBody>
                        <div style={{ position: "absolute", top: 20, right: 20, cursor: 'pointer', zIndex: 1000, color: '#231F20' }} onClick={() => { this.modalCancelButtonClicked() }}>
                            <img src={closeIcon} alt="" />
                        </div>
                        <div className="switchAccountOuterMainContainer col-md-12 p-0 pb-5" style={{ borderRadius: 6 }}>
                            <div className="col-md-12 " style={{ height: '125px', borderRadius: '6px 6px 0 0px', background: '#EBEBEB', position: 'relative' }}>
                                <div className="col-md-12 pt-4" style={{ color: '#231F20', fontSize: 24, fontWeight: '25px', paddingLeft: 62 }}>{this.props.locales.selectAccountTextInSwitchAccountModal}</div>
                            </div>
                            {this.populateAllAcounts()}
                        </div>

                    </ModalBody>
                </Modal>

                

            </div>
        );
    }
}


const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails,
        isSwitchAccountModalVisible: state.isSwitchAccountModalVisible,
        contextParameters: state.contextParameters
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setUserDetails: function (key, payload) {
            dispatch(setUserDetails(key, payload));
        },
        setSwitchAccountModalTrue: function () {
            dispatch(setSwitchAccountModalTrue());
        },
        setSwitchAccountModalFalse: function () {
            dispatch(setSwitchAccountModalFalse());
        }
    }
}

const PortalPageRootComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(PortalPageRootComponent)


export default PortalPageRootComponentContainer;


